import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component';
import PiePage from '../../utils/PiePage.component'
import InputField from '../../utils/InputMUI'
import SelectField from '../../utils/SelectMUI';
import MultiSelect from '../../utils/MultiSelectMUI'
import { getDocumentTempListByPageEntry, SaveUpdateDocumentConfig } from '../ActionCreator';
import Popup from '../../../../../presentationals/Popup/Popup.component'


const FlowData = [
    { name: "L3", code: "L3" },
    { name: "L5", code: "L5" },
]
const loanTypeData = [
    { name: "BL", code: "BL" },
    { name: "SVL", code: "SVL" },
]
const licenseNameData = [
    { name: "AMU", code: "amu" },
]
const bussinessTypeData = [
    { name: "Private Limited", code: "private_limited" },
    { name: "Partnership", code: "partnership" },
    { name: "LLP", code: "llp" },
    { name: "Proprietorship", code: "proprietorship" },
]

const typeData = [
    { name: "PRE", code: "PRE" },
    { name: "POST", code: "POST" },
]

const productData = [
    { name: "COMMUNITY", code: "COMMUNITY" },
    { name: "USER", code: "USER" },
]



const docTypesAllowedData = [
    { name: "PDF", code: "pdf" },
    // { name: "Excel", code: "excel" },
    { name: "JPG", code: "jpg" },
    { name: "PNG", code: "png" },
    // { name: "AAC", code: "aac" },
]

const mandatoryOrNotData = [

    { name: "Yes", code: true },
    { name: "No", code: false },
]



export default function AddDocument({ Editdata }) {
    const [loader, setLoader] = useState(false)
    const [responseMsg, setResponseMsg] = useState("")
    const [errors, setErrors] = useState({});
    const [nameData, setNameData] = useState([])
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" })
    const [objectDataNew, setobjectDataNew] = useState({
        bussinessType: "",
        product: "",
        name: "",
        type: 'POST',
        docTypesAllowed: [],
        mandatoryOrNot: '',
        sizeLimit: '',
        type: '',
        description: '',
        loanType: '',
    })

    useEffect(() => {
        console.log("Editdata", Editdata)
        if (Editdata?.id) {

            setobjectDataNew({
                bussinessType: Editdata?.bussinessType || "",
                product: Editdata?.product || "",
                name: Editdata?.name || "",
                type: Editdata?.type || '',
                docTypesAllowed: Editdata?.docTypesAllowed || [],
                mandatoryOrNot: Editdata?.mandatoryOrNot,
                sizeLimit: Editdata?.sizeLimit || '',
                type: Editdata?.type || '',
                description: Editdata?.description || '',
                loanType: Editdata?.loanType || '',

            })
        } else {
            setobjectDataNew({
                bussinessType: "",
                product: "",
                name: "",
                type: '',
                docTypesAllowed: [],
                mandatoryOrNot: '',
                sizeLimit: '',
                type: '',
                description: '',
                loanType: '',

            })
        }
    }, [Editdata])


    useEffect(() => {
        DocListAPI(1)
    }, [])

    const inputChange = (e, type) => {
        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))
    }

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!objectDataNew.model) {
            formErrors.model = "Model is required";
            isValid = false;
        }

        if (!objectDataNew.make) {
            formErrors.make = "Vehicle Make is required";
            isValid = false;
        }
        if (!objectDataNew.makeClass) {
            formErrors.makeClass = "Vehicle Make Class is required";
            isValid = false;
        }
        if (!objectDataNew.vehicleType) {
            formErrors.vehicleType = "Vehicle Type is required";
            isValid = false;
        }
        if (!objectDataNew.variant) {
            formErrors.variant = "Vehicle Variant is required";
            isValid = false;
        }
        if (!objectDataNew.year) {
            formErrors.year = "Year is required";
            isValid = false;
        }
        if (!objectDataNew.loanType) {
            formErrors.year = "Loan Type is required";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const DocListAPI = (page) => {
        getDocumentTempListByPageEntry(page, 100, callBack => {
            console.log(callBack)
            if (callBack && callBack?.length > 0) {
                const arr = []
                callBack?.map((value) => {
                    const obj = { name: '', code: '' }
                    obj.name = obj.code = value?.docName
                    arr.push(obj)
                })
                setNameData(arr)
            } else {
                setNameData([])
            }
        })
    }

    const saveHandler = (type) => {


        // if (validateForm()) {
        setLoader(true)
        const obj = { ...objectDataNew }
        if (Editdata?.id) {
            obj.id = Editdata?.id
            obj.documentId = Editdata?.documentId
        }
        SaveUpdateDocumentConfig(obj, (callback) => {
            setLoader(false)
            console.log("call", callback)
            if (callback == "success") {
                setShowPopup({ show: true, popupStatus: 'Document Configurations Saved Successfully' })
            } else {
                setShowPopup({ show: true, popupStatus: 'Error Saving Document Configurations' })
            }
        })

        // }
        removePopup()

    }

    const closePopup = () => {
        setShowPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const RemoveErrors = () => {
        setTimeout(() => {
            setErrors({})
        }, 3000)
    }

    return (
        <div className="communitySection" style={{ marginTop: '30px' }}>
            <div className='container hoverNone card'>
                {loader ?
                    <Loader />
                    : null}

                {
                    showPopup?.show ?
                        <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                        : ''}


                <PiePage
                    totalPage={1}
                    currentPage={1}
                    heading={'Add Document Config'}
                />


                <div className='row' style={{ marginBottom: '12px' }}>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.bussinessType}
                            label="Business Type"
                            onChange={e => inputChange(e, 'bussinessType')}
                            name="bussinessType"
                            id="bussinessType"
                            data={bussinessTypeData}
                            size={'small'}

                        />

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.product}
                            label="Product"
                            onChange={e => inputChange(e, 'product')}
                            name="product"
                            id="product"
                            data={productData}
                            size={'small'}

                        />

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.name}
                            label="Name"
                            onChange={e => inputChange(e, 'name')}
                            name="name"
                            id="name"
                            data={nameData}
                            size={'small'}

                        />

                    </div>

                </div>

                <div className="row" style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        <SelectField
                            value={objectDataNew.type}
                            label="Type"
                            onChange={e => inputChange(e, 'type')}
                            name="type"
                            id="type"
                            data={typeData}
                            size={'small'}

                        />


                        {/* {errors.variant && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.variant}</span>
                        )} */}
                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <MultiSelect
                            label={"Doc Types Allowed"}
                            onChange={(e) => inputChange(e, "docTypesAllowed")}
                            value={objectDataNew?.docTypesAllowed ? objectDataNew?.docTypesAllowed : []}
                            inputData={docTypesAllowedData} />

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.mandatoryOrNot}
                            label="Mandatory Or Not"
                            onChange={e => inputChange(e, 'mandatoryOrNot')}
                            name="mandatoryOrNot"
                            id="mandatoryOrNot"
                            data={mandatoryOrNotData}
                            size={'small'}

                        />

                    </div>
                </div>
                <div className="row" style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Size Limit(in MB)"
                            variant="outlined"
                            value={objectDataNew.sizeLimit}
                            name="sizeLimit"
                            id="sizeLimit"
                            type="text"
                            onChange={e => inputChange(e, 'sizeLimit')}
                            size="small"
                        // required={true}
                        />
                        {/* {errors.variant && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.variant}</span>
                        )} */}
                    </div>
                    {/* {
                        objectDataNew?.product === "USER" ?
                            <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                <SelectField
                                    value={objectDataNew.type}
                                    label="Type"
                                    onChange={e => inputChange(e, 'type')}
                                    name="type"
                                    id="type"
                                    data={typeData}
                                    size={'small'}

                                />

                            </div>
                            : ''} */}
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        <InputField
                            label="Description"
                            variant="outlined"
                            value={objectDataNew.description}
                            name="description"
                            id="description"
                            type="text"
                            onChange={e => inputChange(e, 'description')}
                            size="small"
                        // required={true}
                        />

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={objectDataNew.loanType}
                            label="Loan Type"
                            onChange={e => inputChange(e, 'loanType')}
                            name="loanType"
                            id="loanType"
                            data={loanTypeData}
                            size={'small'}

                        />

                    </div>


                </div>

                <div className='mb-3 mt-2 row' style={{ margin: '20px 0 15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

